// "Buy it with" minimum order quantities. The Globo widget's product data has no metafields,
// so each related product's custom.moq is fetched from templates/product.moq.liquid
// (/products/<handle>?view=moq -> {"<variant id>": moq}). Without this every ticked product
// went into the cart at quantity 1. If the fetch fails the quantity falls back to 1 and the
// cart page's MOQ safety net (assets/main.js) raises it.
function loadRelatedMoq(item) {
  if (!item._moqReady) {
    const link = item.querySelector('a[href*="/products/"]');
    let request = Promise.resolve({});
    if (link) {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.search = 'view=moq';
      // Pass a string, not the URL object: main.js wraps window.fetch and calls
      // .includes() on the first argument, which throws for a URL object.
      request = fetch(url.href).then((response) => (response.ok ? response.json() : {})).catch(() => ({}));
    }
    item._moqReady = request.then((map) => {
      item._moqMap = map || {};
      showRelatedMoq(item);
    });
  }
  return item._moqReady;
}

// Minimum for the variant currently selected in this related product (1 when unknown).
function getRelatedMoq(item) {
  const select = item.querySelector('.ga-product_variant_select');
  const moq = item._moqMap && select ? Number(item._moqMap[select.value]) : 1;
  return moq > 1 ? moq : 1;
}

function showRelatedMoq(item) {
  const moq = getRelatedMoq(item);
  let label = item.querySelector('.ga-product_moq');
  if (moq <= 1) {
    if (label) label.remove();
    return;
  }
  if (!label) {
    label = document.createElement('span');
    label.className = 'ga-product_moq';
    const price = item.querySelector('.ga-product_price-container');
    if (price) price.after(label);
    else item.appendChild(label);
  }
  label.textContent = `Min. order ${moq}`;
}

// Override the original Shopify "Add to Cart" button functionality
async function initRelatedProductsAddToCart() {
  const originalAddToCartBtn = document.querySelector('.product-info__add-to-cart .product-info__add-button .btn');

  if (originalAddToCartBtn) {
    originalAddToCartBtn.addEventListener('click', async function (e) {
      e.preventDefault(); // Prevent default behavior

      // Collect all items to add in a single request
      const items = [];

      // Make sure every ticked product's minimum order is known before building the request
      const checkedItems = Array.from(document.querySelectorAll('.ga-products .selectedItem:checked'))
        .map((checkbox) => checkbox.closest('.ga-product'))
        .filter(Boolean);
      await Promise.all(checkedItems.map(loadRelatedMoq));

      // Add the selected related products to the items array
      addSelectedRelatedProductsToItemsArray(items);

      // Add the main product to the items array
      addMainProductToItemsArray(items);

      // Add all items to the cart in a single request
      await addMultipleItemsToCart(items);

      // Optional: Refresh cart after adding
      refreshCart();
      window.location.href = '/cart';
    });
  }

  // Function to add the main product to the items array
  function addMainProductToItemsArray(items) {
    const mainProductVariantId = document.querySelector('input[name=id]').value; // Adjust this to target the main product's variant selector
    const mainProductQuantity = document.querySelector('input[name=quantity]').value || 1; // Adjust this to target the quantity selector
    items.push({
      id: mainProductVariantId,
      quantity: mainProductQuantity
    });
  }

  // Function to add selected related products to the items array
  function addSelectedRelatedProductsToItemsArray(items) {
    const selectedProducts = document.querySelectorAll('.ga-products .selectedItem:checked'); // Select all checked items

    selectedProducts.forEach(function (checkbox) {
      const relatedProductId = checkbox.closest('.ga-product').getAttribute('data-product-id'); // Get the related product ID
      const variantId = checkbox.closest('.ga-product').querySelector('.ga-product_variant_select').value; // Get the variant ID
      items.push({
        id: variantId,
        quantity: getRelatedMoq(checkbox.closest('.ga-product')) // its minimum order, 1 when it has none
      });
    });
  }

  // Function to add multiple items to the cart via Shopify AJAX API
  async function addMultipleItemsToCart(items) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      })
            .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw err; });
      }
      return response.json();
    })
    .then(data => {
      // Dispatch the 'on:cart:add' event
      document.dispatchEvent(new CustomEvent('on:cart:add', {
        detail: {
          cart: data
        },
        bubbles: true
      }));

      // Dispatch the 'dispatch:cart-drawer:refresh' event to refresh the cart drawer
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));

      // Open the cart drawer
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        bubbles: true
      }));

      // Optionally, update the cart count
      if (data && data.item_count !== undefined) {
        updateCartCount(data.item_count);
      }
    })
    .catch((error) => {
      console.error('Error adding item to cart:', error);

      // Dispatch the 'on:cart:error' event
      document.dispatchEvent(new CustomEvent('on:cart:error', {
        detail: {
          error: error.message || 'An error occurred while adding the item to the cart.'
        },
        bubbles: true
      }));
    });
      //const data = await response.json();
      //console.log('Products added to cart:', data);
      //return data;
    } catch (error) {
      console.error('Error adding products to cart:', error);
    }
  }

  // Optional: Function to refresh the cart or show the cart drawer
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); // This will open the cart drawer if you have it enabled
  }
}

// Function to initialize the add-to-cart functionality
function moveRelatedProductDivs() {
  // Select all list items with the class 'ga-product'
  const gaProductListItems = document.querySelectorAll('.ga-product');

  gaProductListItems.forEach(function (listItem) {
    // Find the .ga-product_addtocart_wp element within the current list item
    const productVariantsContainer = listItem.querySelector('.ga-product_variants-container');
    // Find the .ga-related-vertical-content element within the current list item
    const productPriceContainer = listItem.querySelector('.ga-product_price-container');
    const productMain = listItem.querySelector('.product_main > div');
    
    // Check if both elements exist
    if (productVariantsContainer && productPriceContainer && productMain) {
      // Move the .ga-product_addtocart_wp element into the .ga-related-vertical-content element
      productMain.appendChild(productVariantsContainer);
      productMain.appendChild(productPriceContainer);      
    }
  });
  const productContainer = document.querySelector('.ga-products');
  const productTotal = '<div class="niori-product-total"><div>Total: <span class="niori-product_totalprice money"></span></div><div>Items: <span class="niori-product_item"></span></div></div>';
  productContainer.insertAdjacentHTML('beforeend', productTotal);
  
  // Select all checkboxes related to the items
  const checkboxes = document.querySelectorAll('.ga-products .selectedItem');

  // Add event listeners to each checkbox
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', calculateTotalPrice); // Call calculateTotalPrice on change
  });

  // Select the main product quantity input and buttons
  const mainProductQuantityInput = document.querySelector('.qty-input__input');
  const qtyButtons = document.querySelectorAll('.qty-input button');
  const variantOptions = document.querySelectorAll('.ga-product_variant_select');
  const selectOptions = document.querySelectorAll('.custom-select__option');
  
  // Add event listeners to the quantity input field
  if (mainProductQuantityInput) {
    mainProductQuantityInput.addEventListener('input', calculateTotalPrice); // Call calculateTotalPrice when quantity is manually changed
  }

  // Add event listeners to the increment/decrement buttons
  if (qtyButtons) {
    qtyButtons.forEach(function (button) {
      button.addEventListener('click', delayCalculateTotalPrice); // Call calculateTotalPrice on button click
    });
  }

  if (variantOptions) {
    variantOptions.forEach(function (variant) {
      variant.addEventListener('change', delayCalculateTotalPrice); // Call calculateTotalPrice on button click
      // the minimum can differ per variant
      variant.addEventListener('change', function () {
        const item = variant.closest('.ga-product');
        if (item) showRelatedMoq(item);
      });
    });
  }

  if (selectOptions) {
    selectOptions.forEach(function (select) {
      select.addEventListener('click', delayCalculateTotalPrice); // Call calculateTotalPrice on button click
    });
  }
/*
  // Function to calculate the total price
  function calculateTotalPrice() {
    let totalPrice = 0;
    let itemCount = 0;

    // Get the main product price
    const mainProductWholePrice = parseFloat(document.querySelector('.price__current').childNodes[0].nodeValue.replace('£', '').trim()); // Get the whole number part and remove the £ sign
    const mainProductDecimalPrice = parseFloat(document.querySelector('.price__current sup').innerText) / 100; // Get the decimal part

    // Combine whole and decimal parts into a single price value
    const mainProductPrice = mainProductWholePrice + mainProductDecimalPrice;

    // Get the main product quantity
    const mainProductQuantity = parseInt(mainProductQuantityInput.value) || 1;

    // Add the main product price times its quantity
    totalPrice += mainProductPrice * mainProductQuantity;
    itemCount += mainProductQuantity;

    // Loop through all checked related products and add their prices
    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        const relatedProductPrice = parseFloat(checkbox.closest('.ga-product').querySelector('.ga-product_price').childNodes[0].nodeValue.replace('£', '').trim()); // Assuming data-price attribute contains the price in cents
        totalPrice += relatedProductPrice; // Divide by 100 to convert cents to pounds
        itemCount += 1;
      }
    });

    // Update the total price and item count in the DOM
    document.querySelector('.niori-product_totalprice').textContent = `£${totalPrice.toFixed(2)}`; // Convert total price to two decimal places
    document.querySelector('.niori-product_item').textContent = itemCount;
  }
*/
  
// Currency-specific parsing configurations based on your Shopify setup
const CURRENCY_CONFIGS = {
  // No decimals currencies (from your no_cent list)
  'XPF': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'HUF': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 }, // Ft
  'ISK': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'JPY': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'MNT': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'PYG': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'RWF': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'KRW': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'SEK': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'UGX': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'UZS': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  'VND': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 },
  
  // Standard currencies with decimals
  'GBP': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'USD': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'EUR': { thousandsSep: '.', decimalSep: ',', decimalPlaces: 2 },
  'CHF': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'INR': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'KES': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'LBP': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'TJS': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'MOP': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'KHR': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'BSD': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'BZD': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'BGN': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // лв
  'AWG': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // NAƒ
  'MKD': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // ден
  'NIO': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // C$
  'PHP': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // ₱
  'DOP': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // RD$
  'FJD': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // FJ$
  'HKD': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // HK$
  'PKR': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // Rs.
  'PEN': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // S/.
  'AED': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // Dhs.
  'QAR': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'WST': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 },
  'KRW': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 0 }, // ₩
  'THB': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // ฿
  'UAH': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // ₴
  'ILS': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // ₪
  'CRC': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // ₡
  'NGN': { thousandsSep: ',', decimalSep: '.', decimalPlaces: 2 }, // ₦
  'RUB': { thousandsSep: ' ', decimalSep: ',', decimalPlaces: 2 }, // ₽
};

// Comprehensive currency symbols mapping based on your Shopify code
const CURRENCY_SYMBOLS = {
  // Multi-character symbols (check these first)
  'Rs.': 'PKR', 'S/.': 'PEN', 'Dhs.': 'AED', 'Gs.': 'PYG',
  'NAƒ': 'AWG', 'KSh': 'KES', 'RD$': 'DOP', 'FJ$': 'FJD', 
  'HK$': 'HKD', 'C$': 'NIO', 'ден': 'MKD', 'лв': 'BGN',
  ' Ft': 'HUF', 'Aƒ;': 'AWG',
  
  // Currency codes
  'QAR': 'QAR', 'WST': 'WST', 'LBP': 'LBP', 'CHF': 'CHF',
  'TJS': 'TJS', 'MOP': 'MOP', 'KHR': 'KHR', 'XPF': 'XPF',
  'ISK': 'ISK', 'JPY': 'JPY', 'MNT': 'MNT', 'PYG': 'PYG',
  'RWF': 'RWF', 'KRW': 'KRW', 'SEK': 'SEK', 'UGX': 'UGX',
  'UZS': 'UZS', 'VND': 'VND', 'BSD': 'BSD', 'BZD': 'BZD',
  'MKD': 'MKD', 'NIO': 'NIO', 'PHP': 'PHP', 'BGN': 'BGN',
  'AWG': 'AWG', 'HUF': 'HUF', 'PKR': 'PKR', 'PEN': 'PEN',
  'AED': 'AED', 'DOP': 'DOP', 'FJD': 'FJD', 'HKD': 'HKD',
  'USD': 'USD', 'EUR': 'EUR', 'GBP': 'GBP', 'INR': 'INR',
  'KES': 'KES', 'LBP': 'LBP', 'TJS': 'TJS', 'MOP': 'MOP',
  'THB': 'THB', 'UAH': 'UAH', 'ILS': 'ILS', 'CRC': 'CRC',
  'NGN': 'NGN', 'RUB': 'RUB', 'CHF': 'CHF',
  
  // Single character symbols (check last to avoid conflicts)
  '£': 'GBP', '$': 'USD', '€': 'EUR', '₹': 'INR', '₩': 'KRW',
  '¥': 'JPY', '₫': 'VND', '₽': 'RUB', '฿': 'THB', '₴': 'UAH',
  '₪': 'ILS', '₡': 'CRC', '₦': 'NGN', '₱': 'PHP',
  
  // Common variations
  'Ush': 'UGX', 'USh': 'UGX', 'UGX': 'UGX'
};

// Function to detect currency from price string
function detectCurrency(priceString) {
  if (!priceString) return 'GBP'; // Default fallback
  
  const cleanString = priceString.toString().trim();
  
  // Debug logging
  console.log('Detecting currency for:', cleanString);
  
  // Check for multi-character symbols first (most specific)
  for (const [symbol, currency] of Object.entries(CURRENCY_SYMBOLS)) {
    if (symbol.length > 1 && cleanString.includes(symbol)) {
      console.log('Found multi-char symbol:', symbol, '->', currency);
      return currency;
    }
  }
  
  // Check for single character symbols
  for (const [symbol, currency] of Object.entries(CURRENCY_SYMBOLS)) {
    if (symbol.length === 1 && cleanString.includes(symbol)) {
      console.log('Found single-char symbol:', symbol, '->', currency);
      return currency;
    }
  }
  
  console.log('No currency detected, defaulting to GBP');
  return 'GBP'; // Default fallback
}

// Shopify sets the presentment currency on every storefront page; only fall back to
// symbol sniffing if that global is missing.
function getActiveCurrency(priceString) {
  return window.Shopify?.currency?.active || detectCurrency(priceString);
}

// Enhanced price parsing function
function parsePrice(priceString) {
  if (!priceString) return { amount: 0, currency: 'GBP' };
  
  const originalString = priceString.toString().trim();
  const currency = detectCurrency(originalString);
  const config = CURRENCY_CONFIGS[currency] || CURRENCY_CONFIGS['GBP'];
  
  // Remove all currency symbols and codes (start with longest first)
  let cleanPrice = originalString;
  const sortedSymbols = Object.keys(CURRENCY_SYMBOLS).sort((a, b) => b.length - a.length);
  
  sortedSymbols.forEach(symbol => {
    const escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    cleanPrice = cleanPrice.replace(new RegExp(escapedSymbol, 'gi'), '');
  });
  
  cleanPrice = cleanPrice.trim();
  
  // Handle specific formatting based on currency
  if (config.decimalPlaces === 0) {
    // No decimal currencies - remove all separators except handle European format
    if (currency === 'EUR' && cleanPrice.includes('.') && cleanPrice.includes(',')) {
      // European format with both separators
      cleanPrice = cleanPrice.replace(/\./g, '').replace(',', '.');
    } else {
      // Remove all separators for whole number currencies
      cleanPrice = cleanPrice.replace(/[,.\s]/g, '');
    }
  } else {
    // Handle decimal currencies
    if (config.thousandsSep === '.' && config.decimalSep === ',') {
      // European format: 1.234.567,89
      const lastCommaIndex = cleanPrice.lastIndexOf(',');
      const lastDotIndex = cleanPrice.lastIndexOf('.');
      
      if (lastCommaIndex > -1 && lastDotIndex > -1) {
        if (lastCommaIndex > lastDotIndex) {
          // Comma is decimal separator
          cleanPrice = cleanPrice.replace(/\./g, '').replace(',', '.');
        } else {
          // This shouldn't happen in European format, but handle it
          cleanPrice = cleanPrice.replace(/,/g, '');
        }
      } else if (lastCommaIndex > -1) {
        // Only comma - check if it's decimal or thousands
        const parts = cleanPrice.split(',');
        if (parts.length === 2 && parts[1].length <= 2) {
          // Decimal separator
          cleanPrice = cleanPrice.replace(',', '.');
        } else {
          // Thousands separator
          cleanPrice = cleanPrice.replace(/,/g, '');
        }
      } else if (lastDotIndex > -1) {
        // Only dot in European currency - likely thousands separator
        const parts = cleanPrice.split('.');
        if (parts.length === 2 && parts[1].length <= 2) {
          // Could be decimal, keep as is
        } else {
          // Thousands separator
          cleanPrice = cleanPrice.replace(/\./g, '');
        }
      }
    } else if (config.thousandsSep === ' ') {
      // Space as thousands separator (Russian)
      cleanPrice = cleanPrice.replace(/\s+/g, '');
      if (config.decimalSep === ',') {
        cleanPrice = cleanPrice.replace(',', '.');
      }
    } else {
      // Standard format (comma thousands, dot decimal)
      if (cleanPrice.includes(',') && cleanPrice.includes('.')) {
        const lastCommaIndex = cleanPrice.lastIndexOf(',');
        const lastDotIndex = cleanPrice.lastIndexOf('.');
        
        if (lastDotIndex > lastCommaIndex) {
          // Format: 1,234.56
          cleanPrice = cleanPrice.replace(/,/g, '');
        } else {
          // Format: 1.234,56 (shouldn't happen in standard format)
          cleanPrice = cleanPrice.replace(/\./g, '').replace(',', '.');
        }
      } else if (cleanPrice.includes(',')) {
        // Only comma - determine role
        const parts = cleanPrice.split(',');
        if (parts.length === 2 && parts[1].length <= 2) {
          // Decimal separator
          cleanPrice = cleanPrice.replace(',', '.');
        } else {
          // Thousands separator
          cleanPrice = cleanPrice.replace(/,/g, '');
        }
      }
      // Dots are handled as-is for standard format
    }
  }
  
  const amount = parseFloat(cleanPrice) || 0;
  return { amount, currency };
}

// Function to format price according to currency
function formatPrice(amount, currency) {
  const config = CURRENCY_CONFIGS[currency] || CURRENCY_CONFIGS['GBP'];
  
  // For currencies without decimals, round to whole number
  if (config.decimalPlaces === 0) {
    amount = Math.round(amount);
  }
  
  // Find the appropriate symbol for display
  let displaySymbol = currency;
  for (const [symbol, curr] of Object.entries(CURRENCY_SYMBOLS)) {
    if (curr === currency) {
      displaySymbol = symbol;
      break;
    }
  }
  
  try {
    // Try browser's built-in formatting first
    return amount.toLocaleString(undefined, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: config.decimalPlaces,
      maximumFractionDigits: config.decimalPlaces
    });
  } catch (error) {
    // Fallback manual formatting
    let formattedAmount;
    
    if (config.decimalPlaces === 0) {
      formattedAmount = Math.round(amount).toString();
    } else {
      formattedAmount = amount.toFixed(config.decimalPlaces);
      
      // Apply decimal separator
      if (config.decimalSep === ',') {
        formattedAmount = formattedAmount.replace('.', ',');
      }
    }
    
    // Apply thousands separator
    if (config.thousandsSep && amount >= 1000) {
      const parts = formattedAmount.split(config.decimalSep);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, config.thousandsSep);
      formattedAmount = parts.join(config.decimalSep);
    }
    
    return `${displaySymbol}${formattedAmount}`;
  }
}

// Read the money format the theme printed for the active currency straight off the
// main price element: the symbol text, which side it sits on ("£14.99" vs "1,023.00 ฿")
// and the separators. Returns null when there is no price to copy.
function readMoneyFormat(priceElement) {
  const text = (priceElement?.textContent || '').trim();
  const first = text.search(/\d/);
  const last = text.search(/\d(?=\D*$)/);
  if (first === -1) return null;

  const number = text.slice(first, last + 1);
  const separators = number.match(/\D/g) || [];
  const sup = priceElement.querySelector('sup');

  // price-as-money.liquid swaps the decimal separator for <sup>, so while the sup is
  // there every separator left in the text is a thousands separator and the decimals
  // are the digits the sup opens with.
  let thousandsSep = separators[0] || ',';
  let decimalSep = thousandsSep === '.' ? ',' : '.';
  let decimals = sup ? (sup.textContent.match(/\d+/)?.[0] || '').length : 0;

  if (!sup && separators.length) {
    const lastSep = separators[separators.length - 1];
    const lastGroup = number.split(lastSep).pop();
    // Three trailing digits means the last separator groups thousands, not decimals.
    if (lastGroup.length !== 3) {
      decimalSep = lastSep;
      decimals = lastGroup.length;
      thousandsSep = separators.length > 1 ? separators[0] : (lastSep === '.' ? ',' : '.');
    }
  }

  return { prefix: text.slice(0, first), suffix: text.slice(last + 1), thousandsSep, decimalSep, decimals };
}

// Function to format price the same way the page prints the product prices
function formatPriceLikePage(amount, format) {
  const [whole, decimals] = amount.toFixed(format.decimals).split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, format.thousandsSep);

  return format.prefix + grouped + (decimals ? format.decimalSep + decimals : '') + format.suffix;
}

// Unit price of one related product, read from its .ga-product_price element (split
// "£2<sup>99</sup>" or single "£2.99" format). Shared by the total and the "Min. order" label.
function relatedUnitAmount(priceElement) {
  const supElement = priceElement.querySelector('sup');
  if (supElement) {
    const wholeText = priceElement.childNodes[0]?.nodeValue?.trim() || '0';
    const decimalText = supElement.innerText || '0';
    const wholeParsed = parsePrice(wholeText);
    const config = CURRENCY_CONFIGS[wholeParsed.currency] || CURRENCY_CONFIGS['GBP'];
    if (config.decimalPlaces === 0) return wholeParsed.amount;
    return wholeParsed.amount + parseFloat(decimalText) / 100;
  }
  return parsePrice(priceElement.textContent).amount;
}

// Updated function to calculate the total price
function calculateTotalPrice() {
  let totalAmount = 0;
  let itemCount = 0;
  let mainCurrency = 'GBP'; // Will be detected from the main product

  try {
    // Get the main product price
    const priceElement = document.querySelector('.price__current');
    let mainProductAmount = 0;
    
    if (priceElement) {
      const supElement = priceElement.querySelector('sup');
      
      if (supElement) {
        // Split format: whole number + decimal in sup
        const wholeText = priceElement.childNodes[0]?.nodeValue?.trim() || '0';
        const decimalText = supElement.innerText || '0';

        // price-as-money.liquid swaps the decimal separator for <sup>, so a trailing
        // currency symbol ends up inside the sup ("1,023<sup>00 ฿</sup>") and the whole
        // part carries no symbol at all. Take the currency from Shopify instead.
        mainCurrency = getActiveCurrency(priceElement.textContent);

        // Only thousands separators can appear in the whole part here.
        const wholeAmount = parseInt(wholeText.replace(/\D/g, ''), 10) || 0;

        // Handle decimal part based on currency configuration
        const config = CURRENCY_CONFIGS[mainCurrency] || CURRENCY_CONFIGS['GBP'];
        if (config.decimalPlaces === 0) {
          // No decimals for this currency
          mainProductAmount = wholeAmount;
        } else {
          const decimalPart = parseFloat(decimalText) / 100;
          mainProductAmount = wholeAmount + decimalPart;
        }
      } else {
        // Single format: entire price in one element
        const parsed = parsePrice(priceElement.textContent);
        mainProductAmount = parsed.amount;
        mainCurrency = getActiveCurrency(priceElement.textContent);
      }
    }

    // Get the main product quantity
    const mainProductQuantity = parseInt(mainProductQuantityInput?.value) || 1;

    // Add the main product price times its quantity
    totalAmount += mainProductAmount * mainProductQuantity;
    itemCount += mainProductQuantity;

    // Loop through all checked related products and add their prices
    if (typeof checkboxes !== 'undefined') {
      checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          const priceElement = checkbox.closest('.ga-product')?.querySelector('.ga-product_price');

          if (priceElement) {
            const relatedProductAmount = relatedUnitAmount(priceElement);

            // Ticked products go into the cart at their minimum order quantity
            const relatedQuantity = getRelatedMoq(checkbox.closest('.ga-product'));
            totalAmount += relatedProductAmount * relatedQuantity;
            itemCount += relatedQuantity;
          }
        }
      });
    }

    // Update the total price and item count in the DOM
    const totalPriceElement = document.querySelector('.niori-product_totalprice');
    const itemCountElement = document.querySelector('.niori-product_item');
    
    if (totalPriceElement) {
      const pageFormat = readMoneyFormat(priceElement);
      totalPriceElement.textContent = pageFormat
        ? formatPriceLikePage(totalAmount, pageFormat)
        : formatPrice(totalAmount, mainCurrency);
    }

    // "Min. order 12 · £35.88": what a tick will actually add, priced like the rest of the page.
    // showRelatedMoq() creates the label; the price part needs the formatters in this scope.
    const labelFormat = readMoneyFormat(priceElement);
    document.querySelectorAll('.ga-products .ga-product').forEach(function (item) {
      const label = item.querySelector('.ga-product_moq');
      const unitPrice = item.querySelector('.ga-product_price');
      if (!label || !unitPrice) return;
      const moq = getRelatedMoq(item);
      const amount = relatedUnitAmount(unitPrice) * moq;
      label.textContent = `Min. order ${moq} · ${labelFormat ? formatPriceLikePage(amount, labelFormat) : formatPrice(amount, mainCurrency)}`;
    });
    
    if (itemCountElement) {
      itemCountElement.textContent = itemCount;
    }
    
    // Debug logging
    console.log(`Total: ${totalAmount}, Currency: ${mainCurrency}, Items: ${itemCount}`);
    
  } catch (error) {
    console.error('Error calculating total price:', error);
    
    // Fallback: set default values
    const totalPriceElement = document.querySelector('.niori-product_totalprice');
    const itemCountElement = document.querySelector('.niori-product_item');
    
    if (totalPriceElement) totalPriceElement.textContent = '£0.00';
    if (itemCountElement) itemCountElement.textContent = '0';
  }
}

// Test function to verify parsing (remove in production)
function testPricing() {
  const testCases = [
    'Ush 8,544,000',    // UGX - no decimals
    'CHF 1,929.00',     // CHF - with decimals
    'Rs. 1,23,456.78',  // PKR
    'S/. 1,234.56',     // PEN
    'Dhs. 1,234.56',    // AED
    'QAR 1,234.56',     // QAR
    '£1,234.56',        // GBP
    '$1,234.56',        // USD
    '€1.234,56',        // EUR
    '¥1,234',           // JPY - no decimals
    '₩1,234',           // KRW - no decimals
    'KSh 1,234.56',     // KES
    'лв 1,234.56',      // BGN
    '₽ 1 234,56',       // RUB - space thousands, comma decimal
    '77,41700 ฿',       // THB - Thai Baht with comma decimal
    '฿ 1,234.56'        // THB - standard format
  ];
  
  console.log('Price parsing tests:');
  testCases.forEach(test => {
    const result = parsePrice(test);
    const formatted = formatPrice(result.amount, result.currency);
    console.log(`${test} -> ${result.amount} ${result.currency} -> ${formatted}`);
  });
}

  function delayCalculateTotalPrice() {
    setTimeout(calculateTotalPrice, 300);
  }
  
  // Initial calculation when the page loads
  calculateTotalPrice();

  // Fetch each related product's minimum order up front so "Min. order N" shows before
  // anything is ticked, then recalculate the total with those quantities.
  Promise.all(Array.from(document.querySelectorAll('.ga-products .ga-product')).map(loadRelatedMoq))
    .then(calculateTotalPrice);




  // Select all the checkboxes (hidden ones) and their corresponding labels
  //const checkboxes = document.querySelectorAll('.ga-products .selectedItem');

  // Loop through all selected checkboxes
  checkboxes.forEach(function (checkbox) {
    // Create a new label to wrap the checkbox and custom span
    const label = document.createElement('label');
    label.classList.add('ga-product-checkbox-label');
    
    // Create the custom checkbox span
    const customCheckbox = document.createElement('span');
    customCheckbox.classList.add('ga-product-checkbox');
    
    // Add the SVG icon to the custom checkbox
    customCheckbox.innerHTML = `
      <svg focusable="false" viewBox="2 2 24 24" aria-hidden="true">
        <path d="M13 19.37a.51.51 0 01-.36-.15l-4.5-4.53a.51.51 0 01.72-.69l4 4.1 6.2-9.22a.5.5 0 01.84.55l-6.55 9.73a.47.47 0 01-.37.22z"></path>
      </svg>
    `;

    // Insert the label before the original checkbox
    checkbox.parentNode.insertBefore(label, checkbox);

    // Move the original checkbox inside the label (but keep it hidden)
    label.appendChild(checkbox);
    label.appendChild(customCheckbox);

    // Hide the original checkbox
    checkbox.style.display = 'none';

    // Add event listener to the custom checkbox
    label.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent default checkbox behavior

      // Toggle the checked state of the original checkbox
      checkbox.checked = !checkbox.checked;

      // Toggle the 'checked' class on the custom checkbox
      if (checkbox.checked) {
        customCheckbox.classList.add('checked');
      } else {
        customCheckbox.classList.remove('checked');
      }

      // Manually trigger the change event for the original checkbox
      checkbox.dispatchEvent(new Event('change')); // Trigger the change event

      // Call the calculateTotalPrice function
      calculateTotalPrice();
    });
  });
  
  
}

// Function to observe the DOM for the related products section
function observeRelatedProductsSection() {
  const targetNode = document.body; // Observe the entire body or a specific container
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver((mutationsList, observer) => {
    // Check if the elements are present
    if (document.querySelector('.ga-products')) {
      // Elements are found, initialize the add-to-cart functionality
      observer.disconnect();
      // Initialize the related products add-to-cart functionality
      setTimeout(moveRelatedProductDivs, 500);
      setTimeout(initRelatedProductsAddToCart, 1000);
    }
  });

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
}

// Start observing when the script loads
observeRelatedProductsSection();
